import React, { useEffect, useState } from "react";

import "../../Assets/Styles/pages/landing.scss";
import BlogsTile from "../BlogsTile/blogsTile";
import ButtonRounded from "../Signature/button";
import { Col, Row } from "react-bootstrap";

const BlogsList = ({ limit }) => {
  const [blogs, setBlogs] = useState([]);
  const apiUrl = process.env.REACT_APP_GHOST_API_URL;
  const apiKey = process.env.REACT_APP_CONTENT_API_KEY;

  const fetchBlogs = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/ghost/api/content/posts/?key=${apiKey}&include=authors,tags&limit=3`,
        {
          headers: {
            "Accept-Version": "v5.69",
          },
        }
      );

      if (response.ok) {
        const blogsList = await response.json();
        const filteredBlogs = blogsList.posts?.map((blog) => {
          return {
            title: blog.title,
            slug: blog.slug,
            url: blog.url,
            feature_image: blog.feature_image,
            excerpt: blog.excerpt,
          };
        });
        setBlogs(filteredBlogs);
      } else {
        console.error("Error: Unable to fetch blogs data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <Row className="justify-content-start">
      {blogs &&
        blogs?.map((item, i) => (
          <Col key={i} xs={6}>
            {" "}
            <BlogsTile item={item} />{" "}
          </Col>
        ))}

      {typeof limit === "number" && (
        <ButtonRounded
          onclick={() => {
            window.location.href = `${apiUrl}`;
          }}
          text={"ViewAll1"}
          style={"w_edit_button  mb-1"}
          parrentStyle={"w-100"}
        />
      )}
    </Row>
  );
};

export default BlogsList;
